export default {
  hr: {
    menu: {
      profile: "Profil",
      performances: "Performans",
      hiring: "İşe Alım",
      trainings: "Eğitimler",
      expenses: "Harcamalar",
      imprests: "Avanslar",
      papers: "Evraklar",
      documents: "Dokümanlar",
      health: "Sağlık",
      debit_tickets: "Zimmetler",
      payroll: "Bordrolar",
      payslip_explanation: "Bordro Açıklaması",
      events: "Etkinlikler",
      approvals: "Onay Bekleyen Talepler",
      expense_approval: "Harcama Talepleri",
      imprest_approval: "Avans Talepleri",
      messages: "Mesajlar",
      inbox: "Gelen Kutusu",
      outbox: "Giden Kutusu",
      suggestions: "Görüş & Öneriler",
      notes: "Notlar",
      travels: "Seyahatlar",
      travel_requests: "Seyahat Talepleri",
      vehicles: "Araçlar",
      menus: "Yemek Menüsü",
      contact: "İletişim",
      expense: "Harcama",
      expense_request_history: "Harcama Talep Geçmişi",
      imprest: "Avans",
      imprest_request_history: "Avans Talep Geçmişi",
      travel: "Seyahat",
      travel_request_history: "Seyahat Talep Geçmişi",
      debit_ticket_transfer_requests: "Zimmet Transfer Talepleri",
      training: "Eğitim",
      training_requests: "Eğitim Talepleri",
      training_request_history: "Eğitim Talep Geçmişi",
      survey: "Anket",
      pending_surveys: "Bekleyen Anketlerim",
      completed_surveys: "Katıldığım Anketler",
      my_team: "Ekibim"
    },
    account: {
      overview: "Hızlı Bakış",
      email: "E-posta",
      profile: "Profil",
      language_role: "Dil & Rol",
      contact: "İletişim",
      personal: "Kişisel",
      family: "Aile",
      education: "Eğitim",
      employment: "Görevlendirme",
      financial: "Finansal",
      social_media: "Sosyal Medya",
      body_size: "Vücut Ölçüleri",
      mobile_device: "Mobile Cihazlar",
      special_fields: "Özel Alanlar",
      messages: "Mesajlar",
      notes: "Notlar",
      management: "Yönetim"
    },
    employee: {
      overview: {
        staff_number: "Sicil No",
        branch: "Şube",
        unit: "Birim",
        team: "Takım",
        email: "E-posta",
        job_info: "Görev Tanımı",
        leave: {
          manager: "İzin Yöneticisi",
          managers: "İzin Yöneticileri",
          approver: "İzni Onaylayan"
        },
        hired_date: "İşe Alım Tarihi",
        status: "Durum",
        manager: "Genel Yöneticisi",
        shift_manager: "Vardiya Yöneticisi",
        shift_managers: "Vardiya Yöneticileri",
        role: "Rol"
      },
      information: {
        identity_number: "Kimlik No",
        first_name: "Adı",
        last_name: "Soyadı",
        work_email: "E-posta (İş)",
        phone: "Telefon",
        email_and_sms_send_question: "Bu çalışana e-mail ve sms bilgilendirmesi gönderilsin mi?"
      },
      profile: {
        identity_number: "Kimlik No",
        first_name: "Adı",
        last_name: "Soyadı",
        work_email: "E-posta (İş)",
        phone: "Telefon",
        email_and_sms_send_question: "Bu çalışana e-mail ve sms bilgilendirmesi gönderilsin mi?",
        service_line: "Servis Hattı"
      },
      language_role: {
        language: "Dil",
        role: "Rolü"
      },
      contact: {
        email: "E-posta",
        address: "Adres",
        secondary_phone: "İkinci Telefon",
        fixed_phone: "Sabit Telefon",
        work_phone: "İş Telefonu",
        spouse_phone: "Eş Telefonu",
        extension_number: "Dahili Kodu",
        emergency_contact_name: "Acil Durum Adı Soyadı",
        emergency_contact_phone: "Acil Durum Telefonu"
      },
      personal: {
        pasaport_number: "Pasaport Numarası",
        birth_date: "Doğum Tarihi",
        place_of_birth: "Doğum Yeri",
        nationality: "Uyruk",
        blood_type: "Kan Grubu",
        gender: "Cinsiyet",
        disability_level: "Engel Derecesi",
        ex_convict: "Sabıkalı",
        driver: "Şoför",
        military_service: "Askerlik",
        suspended_until: "kadar askıya alındı",
        hes_code: "HES Kodu",
        hes_expired_date: "HES Kodu Geçerlilik Tarihi"
      },
      family: {
        marital_status: "Medeni Durumu",
        spouse_name: "Eşi'nin Adı",
        child_count: "Çocuk Sayısı",
        tenant: "Kiracı",
        martyrs_relatives: "Şehit akrabası",
        disability_child_count: "Engelli Çocuk Sayısı",
        date_of_marriage: "Evlenme Tarihi",
        father_name: "Baba Adı",
        mother_name: "Anne Adı",
        mothers_maiden_name: "Anne Kızlık Soyadı",
        sibling_count: "Kardeş Sayısı",
        child_info: "Çocuk Bilgisi",
        add_child_info: "Çocuk Bilgisi Ekle"
      },
      education: {
        graduation: "Mezuniyet",
        school: "Okul",
        faculty: "Fakülte",
        department: "Bölüm",
        graduation_grade: "Mezuniyet Derecesi",
        academic_title: "Akademik Ünvan",
        languages: "Diller",
        licence_file: "Lisans Dosyası"
      },
      employment: {
        staff_number: "Sicil No",
        branch: "Şube",
        unit: "Birim",
        team: "Takım",
        job_info: "Görev",
        manager: "Yönetici",
        agency: "Acenta",
        ssn: "SGK No",
        passive: "Pasif",
        hired_date: "İşe Alım Tarihi",
        started_date: "İşe Başlama Tarihi",
        employment_type: "Çalışma Şekli",
        collar_type: "Yaka Tipi",
        quite_job: "İşten Ayrılma",
        quit_job_reason: "İşten Ayrılma Nedeni",
        quit_job_reason_description: "Açıklama",
        quit_job_date: "İşten Çıkış Tarihi",
        have_an_interview_made: "Mülakat Yapıldı",
        have_an_interview_made_not: "Mülakat Yapılmadı",
        integration_value: "Entegrasyon Numarası",
        research_and_development_person: "Arge Çalışanı",
        social_security_type: "Sosyal Güvenlik Tipi",
        company: "Şirket",
        allowance_date: "Hakediş Başlama Tarihi"
      },
      financial: {
        iban: "IBAN",
        ticket_number: "Yemek Kartı No",
        bank_account_number: "Banka Hesap Numarası",
        bank_branch: "Hesap Şubesi",
        salary: "Maaşı",
        ticket_price: "Yemek Kartı Bakiyesi",
        previous_salary: "Önceki Maaşı",
        previous_ticket_price: "Önceki Yemek Kartı Bakiyesi",
        yearly_premium: "Yıllık Prim",
        monthly_stoppage: "Aylık Stopaj",
        health_insurance_person_count: "Ailedeki Sigortalı Kişi Sayısı",
        agi: "Asgari Geçim İndirimi (AGİ)",
        gross_salary: "Brüt Maaş",
        pay_to_net: "Net Maaş",
        pay_to_gross: "Brüt Maaş",
        salary_type: "Maaş Ödeme Türü"
      },
      social_media: {
        facebook: "Facebook",
        twitter: "Twitter",
        instagram: "İnstagram",
        linkedin: "Linkedin",
        skype: "Skype"
      },
      body_size: {
        weight: "Kilo",
        height: "Boy",
        shirt_size: "Gömlek Bedeni",
        pants_size: "Pantolon Bedeni",
        shoe_size: "Ayakkabı Numarası",
        waistcoat: "Yelek",
        coat: "Mont"
      },
      management: {
        manager: "Genel Müdür",
        leave_managers: "İzin Yöneticileri",
        shift_managers: "Vardiya Yöneticileri",
        overtime_managers: "Fazla Mesai Yöneticileri",
        expense_managers: "Harcama Yöneticileri"
      },
      mobile_device: {
        serial_number: "Seri Numarası",
        multiple_device_allowed: "Çoklu Cihaz Girişi"
      }
    },
    performance: {
      results: {
        evaluatee: "Değerlendirilen",
        published_evaluators: "Değerlendirenler",
        unpublished_evaluators: "Değerlendirmeyenler",
        kpi_score: "Hedef Puanı",
        competence_score: "Yetkinlik Puanı",
        totalCount: "Toplam Katılımcı",
        publishedCount: "Aktif Katılımcı",
        evaluation_name: "Değerlendirme Adı",
        total_score: "Toplam Puan",
        status: "Durum",
        period: "Dönem",
        scoring: "Puanlama",
        beginDate: "Başlangıç Tarihi",
        endDate: "Bitiş Tarihi"
      },
      table: {
        name: "Değerlendirme Adı",
        type: "Performans Tipi",
        score_range: "Puan Aralığı",
        evaluatee: "Değerlendirilecek Çalışan",
        expiration_period: "Dönem",
        validation_period: "Süre",
        status: "Değerlendirme Durumu",
        categories: "Kategoriler"
      },
      depths: {
        depth_1: "1. Seviye",
        depth_2: "2. Seviye",
        depth_3: "3. Seviye",
        depth_4: "4. Seviye",
        depth_5: "5. Seviye"
      },
      add: {
        kpi: "Hedef Ekle",
        competence: "Yetkinlik Ekle",
        pool: "Havuzdan eklemek istiyorum",
        custom: "Yeni eklemek istiyorum",
        kpi_group: "Hedef Grubu Ekle",
        competence_group: "Yetkinlik Grubu Ekle"
      },
      detail: {
        kpi_group: "Hedef Grubu Detayı",
        competence_group: "Yetkinlik Grubu Detayı"
      },
      crud: {
        detail: {
          template: "Şablon Detayı",
          evaluation: "Değerlendirme Planı Detayı"
        }
      },
      type: {
        KPI: "Hedef",
        COMPETENCE: "Yetkinlik"
      },
      validation: {
        add_item: "{0} kategorisine soru eklemelisiniz",
        template_exist_category: "{0} kategorisine kategori eklenmiş",
        template_must_a_category: "Performans şablonunda en az bir tane kategori olmalı",
        question_total_weight_required: "Soruların ağırlıklarının toplamı {0}% olmak zorundadır",
        question_total_weight: "Soruların ağırlıklarının toplamı {0}%",
        category_not_exist: "Böyle bir kategori mevcut değil",
        category_total_weight_equals_in_questions:
          "{0} kategorisinin toplam ağırlığı {1}% olduğu için bu kategoriye ait soruların toplam ağırlığı {1}% olmak zorundadır",
        category_in_question_required: "{0} kategorisinde en az bir soru olmak zorundadır",
        question_weight_required: "{0} ağırlığını giriniz"
      },
      information:
        '<p class="body-1 mt-5">' +
        "KPI & COMPETENCE kategorilerini seçerek kpi ve competence listenizi oluşturabilirsiniz.\n" +
        "</p>" +
        '<p class="body-1">' +
        "Seçtiğiniz kategoriye tanımlanmış olan kpi ve competence sorularına ağırlıklarını girerek soru bazlı puanlama yapabilirsiniz.\n" +
        "</p>" +
        '<p class="body-1">' +
        "Eklediğiniz listedeki soruların toplamı KPI'a veya COMPETENCE'e belirlediğiniz ağırlığa eşit olmalı.\n" +
        "</p>",
      total_evaluatees_count:
        "Toplam değerlendirmeye katılacak kişi <span class='headline font-weight-bold'>{0}</span>",
      waiting_evaluates_finish: "{0} kişinin değerlendirmeyi tamamlaması bekleniyor",
      complete_evaluation: "Bu değerlendirme tamamlanmış",
      expiration_date: "Bitiş Tarihi",
      template_name: "Şablon Adı",
      kpi: "Hedef",
      kpi_category: "Hedef Kategorisi",
      kpis: "Hedefler",
      competence: "Yetkinlik",
      competence_category: "Yetkinlik Kategorisi",
      competences: "Yetkinlikler",
      result_view: "Sonuçları Göster",
      waiting: "Bekleniyor",
      hourly: "Saatlik",
      weekly: "Haftalık",
      monthly: "Aylık",
      yearly: "Yıllık",
      score: "Puan",
      star: "Yıldız",
      weight: "Ağırlık",
      point: "Puan",
      person: "Kişi",
      persons: "Kişiler",
      period_type: "Periyot",
      score_type: "Puanlama Tipi",
      score_min_count: "En düşük puan",
      score_max_count: "En yüksek puan",
      evaluation: "Değerlendirme",
      evaluatees: "Değerlendirilecekler",
      evaluators: "Değerlendirecekler",
      self: "Kendisi",
      superior: "Üstleri",
      subordinates: "Astları",
      same: "Eşitleri",
      flexible: "Esnek Seçim",
      period: "Değerlendirme Periyodu",
      expiration_dates: "Dönem Aralığı",
      expiration_begin_date: "Değerlendirilecek Dönem Başlangıcı",
      expiration_end_date: "Değerlendirilecek Dönem Bitiş",
      level: "Seviye",
      depth: "Derinlik",
      validation_date: "Değerlendirme Aralığı",
      validation_begin_date: "Değerlendirme Başlangıç Tarihi",
      validation_end_date: "Değerlendirme Bitiş Tarihi",
      published_date_time: "Yayınlanma Tarihi",
      degree_360: "360 °",
      m2m: "M2M",
      published: "Değerlendirmeyi Başlat",
      published_start: "Değerlendir",
      evaluation_done: "Değerlendirildi",
      are_you_sure: "Emin misiniz?",
      are_you_text: "Bu değerlendirmeyi başlatmak istiyor musunuz?",
      performance_item: {
        title: "Performans"
      },
      my_evaluatees: "Değerlendireceklerim",
      my_evaluated: "Değerlendirdiklerim"
    },
    training: {
      plan: "Eğitim Planı",
      name: "Eğitim Adı",
      type: "Eğitim Tipi",
      organizer: "Planlayan",
      lecturer: "Eğitmen",
      terminal: "Terminal",
      sessions: "Oturumlar",
      session: "Oturum",
      training_type: {
        ONLINE: "Online",
        CLASSROOM: "Sınıf",
        ON_SITE: "Saha"
      },
      training_detail: "Eğitim Detayı",
      location: "Lokasyon",
      description: "Açıklama",
      training: "Eğitim",
      request_training: "Eğitim Talep Et",
      training_requests: "Eğitim Talepleri",
      request_date: "Talep Tarihi",
      abolisher: "İptal Eden Çalışan",
      approval_history: "Onaylama Geçmişi",
      cancelled_date: "İptal Edildiği Tarih",
      hr_manager: "İnsan Kaynakları Yöneticisi",
      approval_date: "Onaylama Tarihi",
      cancel_request: "İptal Et",
      cancellation_note: "İptal etme nedeniniz?",
      request_cancellation_process: "Eğitim Talebi İptal İşlemi",
      request_approval_process: "Eğitim Talebi Onaylama İşlemi",
      denied: "Reddet",
      approved: "Onayla",
      training_planned: "Eğitim Planlandın Mı?"
    },
    expense: {
      name: "Harcama Adı",
      type: "Harcama Tipi",
      amount: "Harcama Tutarı",
      date: "Harcama Tarihi",
      status: "Durumu",
      attachment: "Dosya",
      create_expense: "Harcama Talep Et",
      travel: "Seyahat",
      approved_amount: "Onaylanan Tutar"
    },
    imprest: {
      amount: "Tutar",
      period: "Tarih",
      reason: "Sebep",
      status: "Durum",
      create_imprest: "Avans Talep Et",
      travel: "Seyahat",
      approved_amount: "Onaylanan Tutar",
      date: "Tarih"
    },
    paper: {
      type: "Evrak Tipi",
      name: "Evrak Adı",
      issue_date: "Veriliş Tarihi",
      expire_date: "Bitiş Tarihi",
      signature_status: "İmza Durumu",
      signature_types: {
        NOT_REQUIRED: "Zorunlu değil",
        STANDARD_SIGNATURE: "Standart İmza",
        BIOMETRIC_SIGNATURE: "Biyometrik İmza",
        SIGNED: "İmzalı",
        null: "-",
        E_SIGNATURE: "E-İmza"
      },
      add_paper: "Evrak Ekle",
      papers: {
        issue_date: "Veriliş Tarihi",
        expire_date: "Bitiş Tarihi"
      }
    },
    document: {
      name: "Dosya Adı",
      type: "Dosya Tipi",
      sender: "Gönderen",
      date: "Gönderme Tarihi",
      add_document: "Döküman Ekle",
      mobile_accessible_disable: "Mobilde göremez",
      mobile_accessible_enable: "Mobilde görebilir"
    },
    health: {
      name: "Hastalık Adı",
      category: "Hastalık Kategorisi",
      from: "Başlangıç Tarihi",
      to: "Bitiş Tarihi",
      disease_detail: "Hastalık Detayı",
      importance: "Önem",
      importance_enum: {
        LOW: "Düşük",
        MEDIUM: "Orta",
        HIGH: "Yüksek"
      },
      medicines: "İlaçlar",
      attachment: "Ek Dosya",
      description: "Açıklama"
    },
    debit_tickets: {
      asset: "Varlık",
      borrow_date: "Ödünç Alma Tarihi",
      due_date: "Bitiş Tarihi",
      give_back_date: "İade Tarihi",
      quantity: "Adet",
      transfer: "Transfer Et",
      transfer_approval: "Transfer Onaylama",
      approver: "Transfer Edilecek Çalışan",
      debit_transfer: "Zimmet Transferi",
      download_form: "Formu İndir"
    },
    payroll: {
      month: "Ay",
      created_date: "Oluşturulma Tarihi",
      file: "Dosya"
    },
    events: {
      name: "Etkinlik Adı",
      type: "Etkinlik Tipi",
      owner: "Oluşturan",
      online: "Online",
      begin_date: "Başlangıç Tarihi",
      end_date: "Bitiş Tarihi",
      activity: "Etkinlik"
    },
    expense_approval: {
      employee: "Çalışan",
      description: "Açıklama",
      amount: "Tutar",
      status: "Durum",
      request_date: "Talep Tarihi",
      document: "Dosya",
      expense_approval: "Harcama Onaylama",
      message:
        "{0}, <b>{1}</b> tarihinde <b>{2}</b> tipinde <b>{3}</b> harcama talebinde bulundu, onaylamak istiyor musunuz?"
    },
    imprest_approval: {
      employee: "Çalışan",
      amount: "Tutar",
      status: "Durum",
      request_date: "Talep Tarihi",
      imprest_approval: "Avans Onaylama",
      message: "{0}, <b>{1}</b> tarihinde <b>{2}</b> avans talebinde bulundu, onaylamak istiyor musunuz?"
    },
    hiring: {
      job_posting: "İlan",
      applicant: "Başvuran",
      applicants: "Başvuranlar",
      interview: "Görüşme",
      assessment_date: "Görüşme Tarihi",
      working_date: "İşe Başlama Tarihi",
      last_job: "Son çalıştığı iş",
      last_position_level: "Son çalıştığı pozisyon",
      evaluator: "Değerlendiren",
      evaluators: "Değerlendirenler",
      weight: "Ağırlık",
      link: "Link",
      skill: "Yetenek",
      rate: "Oran",
      rating: "Puan Ver",
      table: {
        applicant: "Başvuru Yapan",
        job_posting: "İlan",
        last_job: "Son İşi",
        assessment: "Genel Değerlendirme",
        rating: "Değerlendirme Sonucu",
        assessment_date: "Değerlendirme Tarihi",
        status: "Tamamlanma Durumu",
        evaluators: "Değerlendirenler",
        evaluator: "Değerlendiren"
      },
      skill_type: {
        soft: "Soft",
        technical: "Teknik",
        question: "Soru",
        link: "Link"
      }
    },
    message: {
      message_type: "Mesaj Tipi",
      sender: "Gönderen",
      receivers: "Alıcılar",
      importance: "Önem Derecesi",
      sms: "Sms",
      email: "E-mail",
      in_app: "Bildirim",
      title: "Başlık",
      body: "Mesaj İçeriği",
      whom: "Kime",
      date: "Gönderim Tarihi",
      message_type_enum: {
        EMAIL: "E-posta",
        SMS: "Sms",
        IN_APP: "Bildirim"
      },
      message_importance_enum: {
        LOW: "Düşük",
        MEDIUM: "Orta",
        HIGH: "Yüksek"
      },
      send_message: "Mesaj Gönder",
      success_message: "{0} kişiye {1} gönderildi"
    },
    suggestion: {
      category: "Görüş & Öneri Kategorisi",
      title: "Görüş & Öneriler",
      add_suggestion: "Görüş & Öneri Ekle",
      body: "Mesaj"
    },
    note: {
      notes: "Notlar",
      title: "Başlık",
      body: "İçerik",
      attachment: "Ek Dosya",
      description: "Açıklama",
      add_note: "Not Ekle",
      owner: "Çalışan",
      importance: "Önem Derecesi"
    },
    travel: {
      request_travel: "Seyahat Talep Et",
      leave_request: "İzin Talebi",
      travels: "Seyahatler",
      travel: "Seyahat",
      travel_detail: "Seyahat Detayı",
      start_work_date: "İş Başı Tarihi",
      is_domestic: "Yurt içi seyahat mı?",
      country: "Gidilecek Ülke",
      city: "Gidilecek Şehir",
      region: "Gidilecek Bölge",
      is_rent_car: "Kiralık araç var mı?",
      is_shuttle: "Havalimanı transferi var mı?",
      description: "Açıklama",
      reason: "Sebep",
      status: "Durum",
      expense_message:
        "<strong>{0}</strong>, <strong>{1}</strong> tarihinde <strong>{2}</strong> isminde <strong>{3}</strong> tipinde <strong>{4}</strong> tutarında harcama talebinde bulundu",
      imprest_message:
        "<strong>{0}</strong>, <strong>{1}</strong> tarihinde <strong>{2}</strong> tutarında avans talebinde bulundu",
      subsistence_message:
        "<strong>{0}</strong> isimli çalışana <strong>{1}</strong> tarihinde <strong>{2}</strong> tutarında harcırah verildi",
      travel_dates: "Seyahat Tarihleri",
      pending_travel_approvals: "Bekleyen Seyahat Onayları",
      travel_process: "Seyahat Talebi İşlemi",
      travel_details: "Seyahat Detayları",
      no_detail_item: "Hiç detay eklenmemiş",
      add_new_detail: "Yeni Detay Ekle",
      detail_type: "Detay Tipi",
      detail_subtype: "Detay Alt Tipi",
      travel_detail_type_enum: {
        TRANSFER: "Transfer",
        LAYOVER: "Konaklama",
        BUSINESS: "İş"
      },
      travel_detail_subtype_enum: {
        BUS: "Otobüs",
        PLANE: "Uçak",
        TRAIN: "Tren",
        SHIP: "Gemi",
        CAR: "Otomobil",
        HOTEL: "Otel",
        HOSTEL: "Pansiyon",
        VILLA: "Villa",
        FACTORY: "Fabrika",
        OFFICE: "Ofis"
      },
      begin_date: "Başlangıç Tarihi",
      end_date: "Bitiş Tarihi",
      expenses: "Harcamalar",
      imprests: "Avanslar",
      debits: "Zimmetler",
      borrow_date: "Ödünç Tarihi",
      due_date: "Bitiş Tarihi",
      give_back_date: "Geri Verilme Tarihi",
      quantity: "Adet",
      name: "İsim",
      category: "Kategori",
      model: "Model",
      subsistences: "Harcırahlar",
      project: "Proje",
      attrition: "Yıpranma Payı"
    },
    travel_request: {
      employee: "Çalışan",
      begin_date: "Başlangıç Tarihi",
      end_date: "Bitiş Tarihi",
      start_work_date: "İş Başı Tarihi",
      status: "Durum",
      request_date: "Talep Tarihi",
      travel_approval: "Seyahat Onaylama",
      message:
        "<b>{0}</b>, <b>{1}</b> - <b>{2}</b> tarihleri arasında seyahat talebinde bulundu, onaylamak istiyor musunuz?"
    },
    vehicle: {
      plate_number: "Plaka Numarası",
      brand: "Marka",
      model: "Model",
      year: "Yıl",
      branch: "Şube",
      employee: "Çalışan"
    },
    contact: {
      employee: "Çalışan",
      email: "E-posta",
      phone: "Telefon Numarası"
    },
    projects: {
      project: "Proje",
      employee_count_message: "Çalışan yok | 1 çalışan | {count} çalışan"
    },
    debit_ticket_transfer_request: {
      requester: "Talep Eden",
      asset: "Varlık",
      approval_message:
        "<strong>{0}</strong>, aşağıda bilgileri yer alan varlığı sizin zimmetinize transfer etme talebinde bulundu, onaylamak istiyor musunuz?"
    },
    survey: {
      name: "Anket Adı",
      published_date: "Yayınlanma Tarihi",
      end_date: "Bitiş Tarihi",
      start_survey: "Ankete Başla",
      survey_privacy: "Anket Gizliliği",
      status: "Durum",
      pending_title: "Tamamlamanız Gereken Anketler",
      completed_title: "Katıldığım Anketler",
      complete_survey: "Anketi Tamamla",
      survey_information: "Anket Bilgileri",
      exit: "Çıkış",
      save_and_finish: "Kaydet ve Bitir",
      status_enum: {
        completed: "Tamamlandı",
        continuous: "Devam Ediyor"
      },
      section_count: "Bölüm Sayısı",
      question_count: "Soru Sayısı",
      estimated_duration: "Tahmini Süre",
      description: "Açıklama",
      anonymous_on: "Gizli Oylama",
      anonymous_off: "Açık Oylama",
      enter_answer: "Cevap girebilirsiniz",
      your_answer: "Cevabınız",
      please_select: "Seçiniz"
    },
    employees: {
      employee_profile: "Çalışan Profili",
      staffNumber: "Sicil No",
      email: "E-Posta",
      branch: "Şube",
      unit: "Birim",
      team: "Takım",
      jobInfo: "Görev Tanımı",
      status: "Durum",
      hiredDate: "İşe Alım Tarihi",
      birthDate: "Doğum Tarihi",
      manager: "Genel Yöneticisi",
      hrManagers: "İnsan Kaynakları Yöneticileri",
      leaveManagers: "İzin Yöneticileri",
      shiftManagers: "Vardiya Yöneticileri",
      overtimeManagers: "Fazla Mesai Yöneticileri",
      leaveAccruals: "İzin Hakedişleri",
      active: "Aktif",
      passive: "Pasif",
      leaveType: "İzin Adı",
      accrualCount: "Toplam Hakediş",
      leaveBalance: "İzin Bakiyesi",
      used: "Kullanılan",
      previousBalance: "Önceki Bakiye"
    }
  }
};
